import { call, cancelled, put, takeLatest, select, all } from 'redux-saga/effects';
import { RoutingTypes, RoutingActions } from './routing.redux';
import { getMissions, getAgents, getTouchPoints, postRouting, deleteMission, getTradePrograms, getInvolvements } from './routing.api';
import {globalFiltersRoutingUrlParamsSelector} from '../../modules/root/global-filters/global-filters.selectors';
import {selectedAgentUsernameSelector, localFiltersUrlParamsSelector} from './routing.selectors';
import { dateSelector, selectedAgentSelector, selectedTouchPointsSelector, selectedTasksSelector } from './routing.selectors';

function* getDataRequest() {
    try {
        const globalFilters = yield select(globalFiltersRoutingUrlParamsSelector);
        const localFilters = yield select(localFiltersUrlParamsSelector);
        const date = yield select(dateSelector);
        const [data, dayData, agents, tradePrograms, involvements] = yield all([
            call(getMissions, `${globalFilters}`),
            date ? call(getMissions, `${globalFilters}&date=${encodeURIComponent(date)}`) : null,
            call(getAgents, `${localFilters}`),
            call(getTradePrograms),
            call(getInvolvements)
            //call(getTouchPoints, `${globalFilters}`)
        ]);
        yield put(RoutingActions.getDataSuccess({ by_date: {}, touchpoints: {}, ...data.data, by_staff: dayData && dayData.data ? dayData.data.by_staff : {} }, agents.data, tradePrograms.data.programs, involvements.data));
    } catch (e) {
        yield put(RoutingActions.getDataError(e));
    } finally {
        if (yield cancelled()) {
            yield put(RoutingActions.getDataError(null));
        }
    }
}

function* selectAgent({ id, region, district, territory }) {
    const date = yield select(dateSelector);
    try {
        let filters = `region=${region}`;
        if (district)
            filters += `&district=${district}`;
        if (territory)
            filters += `&territory=${territory}`;

        const agent = yield select(selectedAgentUsernameSelector);

        const [response1, response2] = yield all([
            call(getTouchPoints, filters),
            call(getMissions, `date=${encodeURIComponent(date)}&agent=${encodeURIComponent(agent)}`),
        ]);
        const currentAgent = yield select(selectedAgentSelector);
        const currentDate = yield select(dateSelector);
        if (currentAgent === id && currentDate === date)
            yield put(RoutingActions.getTouchPointsSuccess(response1.data, response2.data));
        else
            yield put(RoutingActions.getTouchPointsError(null));
    } catch (e) {
        const currentAgent = yield select(selectedAgentSelector);
        const currentDate = yield select(dateSelector);
        yield put(RoutingActions.getTouchPointsError(currentAgent === id && currentDate === date ? e : null));
    } finally {
        if (yield cancelled()) {
            yield put(RoutingActions.getTouchPointsError(null));
        }
    }
}

function* addMission() {
    try {
        const date = yield select(dateSelector);
        const agent = yield select(selectedAgentSelector);
        const touchpoints = yield select(selectedTouchPointsSelector);
        const tasks = yield select(selectedTasksSelector);
        const response = yield call(postRouting, { date, agent, touchpoints, tasks });
        yield put(RoutingActions.addMissionSuccess(response.data));
        yield put(RoutingActions.getDataRequest());
    } catch (e) {
        yield put(RoutingActions.addMissionError(e));
    } finally {
        if (yield cancelled()) {
            yield put(RoutingActions.addMissionError(null));
        }
    }
}

function* deleteMissionRequest({ id }) {
    try {
        yield call(deleteMission, id);
        yield put(RoutingActions.deleteMissionSuccess());
        yield put(RoutingActions.getDataRequest());
    } catch (e) {
        yield put(RoutingActions.deleteMissionError(e));
    } finally {
        if (yield cancelled()) {
            yield put(RoutingActions.deleteMissionError(null));
        }
    }
}

export default function* routingSaga() {
    yield takeLatest(RoutingTypes.GET_DATA_REQUEST, getDataRequest);
    yield takeLatest(RoutingTypes.SELECT_AGENT, selectAgent);
    yield takeLatest(RoutingTypes.ADD_MISSION_REQUEST, addMission);
    yield takeLatest(RoutingTypes.DELETE_MISSION_REQUEST, deleteMissionRequest);
    yield takeLatest(RoutingTypes.ACTION_FILTER, function* () {
        yield put(RoutingActions.getDataRequest());
    });

}
